//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { adviceEdit } from "@/api/managementCenter/advices";
export default {
  name: "Advice",
  components: {},
  props: [],
  data: function data() {
    return {
      id: "",
      entryType: "",
      show: false,
      loading: false,
      resultData: {
        answer: ""
      },
      type: "",
      status: "",
      attachUrl: ""
    };
  },
  computed: {},
  methods: {
    // 确定提交
    submitForm: function submitForm(formName) {
      if (!this.resultData.answer) {
        this.$message.warning("请输入要留言的内容!");
        return;
      }

      this.adviceEditFn();
    },
    adviceEditFn: function adviceEditFn() {
      var _this = this;

      this.loading = true;
      var params = {
        id: this.id,
        answer: this.resultData.answer
      };
      adviceEdit(params).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.$message.success("回复成功!");

          _this.$emit("saveSuccess");

          _this.show = false;
        } else {
          _this.$message.warning(data.msg || "回复失败!");
        }
      }).catch(function (err) {
        _this.$message.error("服务器异常!");

        _this.loading = false;
      });
    },
    // 显示弹框
    dialogShow: function dialogShow(entryType, id, data, type, status, attachUrl) {
      var _this2 = this;

      this.entryType = entryType;
      this.id = id;
      this.show = true;

      if (entryType == "detail") {
        this.type = type;
        this.status = status;
        this.attachUrl = attachUrl;
        this.$nextTick(function () {
          _this2.resultData = data;
        });
      } else {
        this.resultData.answer = "";
      }
    },
    download: function download() {
      window.location.href = this.attachUrl;
    }
  },
  watch: {
    show: function show(val) {
      if (!val) {
        this.resultData.answer = "";
      }
    }
  },
  filters: {}
};